var _path, _path2, _line, _line2, _circle, _circle2, _circle3, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBakery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.095,20.427c-.53-1.055-.818-2.19-.818-3.37,0-2.624,1.421-5.017,3.758-6.828-.083-4.499,8.047-7.499,10.964-7.499s11.028,3.341,11.028,7.549c2.299,1.805,3.694,4.178,3.694,6.778,0,1.153-.274,2.261-.78,3.295"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m35.255,20.616l-2.285-1.21c-1.383-.732-3.066-.595-4.312.351l-.331.251c-1.416,1.076-3.371,1.093-4.805.042l-.1-.073c-1.436-1.051-3.393-1.033-4.809.045h0c-1.405,1.069-3.343,1.097-4.777.068l-.586-.42c-1.249-.896-2.901-1.001-4.254-.27l-2.251,1.216,4.234,14.438c.733,2.499,3.026,4.216,5.63,4.216h8.581c2.577,0,4.852-1.681,5.608-4.144l4.457-14.51Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 18.09,
    y1: 38.889,
    x2: 16.193,
    y2: 20.842
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23.91,
    y1: 38.889,
    x2: 25.822,
    y2: 20.842
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.235,
    cy: 7.501,
    r: 0.666
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.773,
    cy: 15.153,
    r: 0.666
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.193,
    cy: 9.581,
    r: 0.666
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 21.672,
    cy: 13.822,
    r: 0.666
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 29.274,
    cy: 15.413,
    r: 0.666
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBakery);
export default __webpack_public_path__ + "static/media/indoor-bakery.296b2eae04fd11dcd802a958e57f8791.svg";
export { ForwardRef as ReactComponent };